import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessDmsBelegausgabeParamInterfaceStatus: 'idle',
    startProcessDmsBelegausgabeParamInterfaceError: undefined as any,
    loadUserParamsProcessDmsBelegausgabeParamInterfaceStatus: 'idle',
    loadUserParamsProcessDmsBelegausgabeParamInterfaceError: undefined as any,

    processDmsBelegausgabeParamInterfaceList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessDmsBelegausgabeParamInterface = createAsyncThunk('processDmsBelegausgabeParamInterfaceSlice/startProcessDmsBelegausgabeParamInterface', async ({ processDmsBelegausgabeParamInterface }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessDmsBelegausgabeParamInterface/`,
        prepareData(processDmsBelegausgabeParamInterface),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessDmsBelegausgabeParamInterfaceStatus } = getState().processDmsBelegausgabeParamInterfaceSlice
        return startProcessDmsBelegausgabeParamInterfaceStatus !== 'pending'
    }
})

export const loadUserParamsProcessDmsBelegausgabeParamInterface = createAsyncThunk('processDmsBelegausgabeParamInterfaceSlice/loadUserParamsProcessDmsBelegausgabeParamInterface', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessDmsBelegausgabeParamInterface/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessDmsBelegausgabeParamInterfaceStatus } = getState().processDmsBelegausgabeParamInterfaceSlice
        return loadUserParamsProcessDmsBelegausgabeParamInterfaceStatus !== 'pending'
    }
})

const ProcessDmsBelegausgabeParamInterfaceSlice = createSlice({
    name: 'processDmsBelegausgabeParamInterfaceSlice',
    initialState,
    reducers: {
        resetstartProcessDmsBelegausgabeParamInterface: (state) => {
            state.job = undefined
            state.startProcessDmsBelegausgabeParamInterfaceError = undefined
        },
        resetstartProcessDmsBelegausgabeParamInterfaceError: (state) => {
            state.startProcessDmsBelegausgabeParamInterfaceError = undefined
        },
        resetloadUserParamsProcessDmsBelegausgabeParamInterface: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessDmsBelegausgabeParamInterfaceError = undefined
        },
        resetloadUserParamsProcessDmsBelegausgabeParamInterfaceError: (state) => {
            state.loadUserParamsProcessDmsBelegausgabeParamInterfaceError = undefined
        },
        removeFromProcessDmsBelegausgabeParamInterfaceListById: (state, action) => {
            state.processDmsBelegausgabeParamInterfaceList = state.processDmsBelegausgabeParamInterfaceList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessDmsBelegausgabeParamInterfaceListByIds: (state, action) => {
            state.processDmsBelegausgabeParamInterfaceList = state.processDmsBelegausgabeParamInterfaceList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processDmsBelegausgabeParamInterfaceList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessDmsBelegausgabeParamInterfaceStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processDmsBelegausgabeParamInterfaceList = []
            state.startProcessDmsBelegausgabeParamInterfaceStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessDmsBelegausgabeParamInterface.pending, (state) => {
            state.startProcessDmsBelegausgabeParamInterfaceStatus = 'pending'
            state.startProcessDmsBelegausgabeParamInterfaceError = undefined
        })
        builder.addCase(startProcessDmsBelegausgabeParamInterface.fulfilled, (state, action) => {
            state.startProcessDmsBelegausgabeParamInterfaceStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessDmsBelegausgabeParamInterface.rejected, (state, action) => {
            state.startProcessDmsBelegausgabeParamInterfaceStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessDmsBelegausgabeParamInterfaceError = action.error.message
            } else {
                state.startProcessDmsBelegausgabeParamInterfaceError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessDmsBelegausgabeParamInterface.pending, (state) => {
            state.loadUserParamsProcessDmsBelegausgabeParamInterfaceStatus = 'pending'
            state.loadUserParamsProcessDmsBelegausgabeParamInterfaceError = undefined
        })
        builder.addCase(loadUserParamsProcessDmsBelegausgabeParamInterface.fulfilled, (state, action) => {
            state.loadUserParamsProcessDmsBelegausgabeParamInterfaceStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessDmsBelegausgabeParamInterface.rejected, (state, action) => {
            state.loadUserParamsProcessDmsBelegausgabeParamInterfaceStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessDmsBelegausgabeParamInterfaceError = action.error.message
            } else {
                state.loadUserParamsProcessDmsBelegausgabeParamInterfaceError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessDmsBelegausgabeParamInterface,
    resetstartProcessDmsBelegausgabeParamInterfaceError,
    resetloadUserParamsProcessDmsBelegausgabeParamInterface,
    resetloadUserParamsProcessDmsBelegausgabeParamInterfaceError,
    removeFromProcessDmsBelegausgabeParamInterfaceListById,
    removeFromProcessDmsBelegausgabeParamInterfaceListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessDmsBelegausgabeParamInterfaceSlice.actions
export default ProcessDmsBelegausgabeParamInterfaceSlice.reducer
